// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './Header';
import Signups from './Signups';
import Commissions from './Commissions';
import { setActiveSection } from './reducer';
import { MONTH_SIGNUPS, YEAR_SIGNUPS, TOP_COMMISSIONS } from './reducer';
import { StatisticsDiv } from './StatisticsStyles';
import { type Currencies } from '../../../utilities/types';
import { getTopCommissions } from './selectors';

export type SignupStats = {|
  signups: number,
  approved: number,
  pending: number,
  partial: number
|};

export type CommissionStat = {|
  currency: string,
  revenue_share: string,
  revenue_share_usd: string
|};

type Props = {
  activeSection: string,
  setActiveSection: (section: string) => void,
  monthSignups: SignupStats,
  yearSignups: SignupStats,
  commissions: CommissionStat[],
  month: string,
  currencies: Currencies
};

class Statistics extends Component<Props> {
  render() {
    return (
      <StatisticsDiv>
        <Header
          activeSection={this.props.activeSection}
          setActiveSection={this.props.setActiveSection}
          month={this.props.month}
        />
        {this.props.activeSection === MONTH_SIGNUPS && (
          <Signups
            {...this.props.monthSignups}
            activeSection={this.props.activeSection}
          />
        )}
        {this.props.activeSection === YEAR_SIGNUPS && (
          <Signups
            {...this.props.yearSignups}
            activeSection={this.props.activeSection}
          />
        )}
        {this.props.activeSection === TOP_COMMISSIONS && (
          <Commissions
            commissions={this.props.commissions.slice(0, 2)}
            currencies={this.props.currencies}
          />
        )}
      </StatisticsDiv>
    );
  }
}

const mapStateToProps = state => ({
  activeSection: state.dashboard.statistics.activeSection,
  month: state.dashboard.statistics.month,
  monthSignups: state.dashboard.statistics.monthSignups,
  yearSignups: state.dashboard.statistics.yearSignups,
  commissions: getTopCommissions(state),
  currencies: state.global.currencies
});

const mapDispatchToProps = {
  setActiveSection
};

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);
